import { useState } from "react";

import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import type { ListsDto, StaticListDto } from "app/pages/sales-intelligence/modules/lists/types/dto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

type StaticListResponse = UseQueryResult<ListsDto<StaticListDto>> & {
    searchText: string;
    page: number;
    setPage: (page: number) => void;
    setSearchText: (searchText: string) => void;
};

const useStaticList = ({ initialPage = 1, pageSize = 10, initSearchText = "" }): StaticListResponse => {
    const [page, setPage] = useState<number>(initialPage);
    const [searchText, setSearchText] = useState<string>(initSearchText);
    const queryData = useQuery({
        queryKey: listsQueryKeys.staticLists(page, searchText),
        retry: false,
        throwOnError: true,
        queryFn(): Promise<ListsDto<StaticListDto>> {
            return salesApiService.lists.fetchStaticLists({ page, pageSize, searchText });
        },
    });

    return {
        ...queryData,
        page,
        searchText,
        setSearchText,
        setPage,
    };
};

export default useStaticList;
